export default {
    show_restrictions_modal_title: "Restricciones",
    show_restrictions_modal_close: "Cerrar",
    show_restrictions_current_config_not_allowed: "La configuración actual no está permitida",
    show_restrictions_current_config_is_allowed: "Se permite la configuración actual",
    show_restrictions_aux_camera: "Cam AUX",
    show_restrictions_model: "Modelo",
    show_restrictions_model2: "Modelo 2",
    show_restrictions_pc_control: "Control de privacidad",
    show_restrictions_video_resolution: "Video",
};